import src from "IMAGE";
export default { src, width: 1668, height: 659, blurWidth: 8, blurHeight: 3, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAIAAAAhqtkfAAAAPklEQVR42h2JSwrAUAgDxTsIbgTxU9tC73+95jmLMEmollwgIsLMSEK5Z773uSojApOqQqi7z9c1le5uZr38SqIJDBAUib0AAAAASUVORK5CYII="};
